/* eslint-disable @typescript-eslint/no-explicit-any */
const initialState: any = {
  isOpen: true
};

export default initialState;
